<template>
    <div class="show-details-container">
        <div class="buton-on-the-right">
            <h2 class="truncate-text">
                {{ show.venue }}
            </h2>
        </div>

        <div style="max-width: 500px;">
            <v-btn size="x-small" color="primary" v-if="displayShowPhotos || displayUsedPhotos"
                @click="viewDetails">Details</v-btn>
            &nbsp;
            <v-btn size="x-small" color="primary" v-if="displayShowDetails" @click="viewPhotos">Photos</v-btn>
            &nbsp;
            <v-btn size="x-small" color="primary" v-if="displayShowDetails" @click="viewUsedPhotos">Used</v-btn>
            &nbsp;
            <v-btn size="x-small" @click="$emit('close-details')">Close</v-btn>
        </div>

        <!-- ======================================================================================= -->

        <div id="divShowDetails" v-if="displayShowDetails">

            <div style="padding-bottom:5px;padding-left: 5px;;">
                <v-btn size="x-small" color="primary" @click="viewEdits">Edit</v-btn>
            </div>

            <div id="justifiedDetailsDiv" style="width:90%">
                <p class="buton-on-the-right">
                    <span class="label">Venue:</span>
                    <span class="details-value">{{ show.venue }}</span>
                </p>
                <p class="buton-on-the-right">
                    <span class="label">Show Date:</span>
                    <span class="details-value">{{ formattedDateWithWeekday }}</span>
                </p>
                <br>
            </div>

            <div class="qrCodeDiv">
                Audience QR Code: <br>
                <QRCode :audienceUrl="audienceAppUrl" :show-url-beneath="true" />
            </div>
        </div>

        <!-- ======================================================================================= -->

        <div v-if="displayShowEdits">
            <div>
                <br>

                <p>
                    <span class="label">Venue:</span> <br>
                    <input type="text" id="edit-venue" v-model="show.venue">
                    <br>
                    <br>
                </p>
                <p>
                    <span class="label">Show Date:</span> <br>
                    <input type="date" id="edit-show-date" v-model="show.showDate">
                    <br>
                    <br>
                </p>
            </div>

            <div style="padding-bottom:5px">
                <v-btn size="small" color="primary" @click="saveShowData">Save</v-btn>
                &nbsp;
                <v-btn size="small" color="primary" @click="viewDetails">Cancel</v-btn>
            </div>
        </div>

        <!-- ======================================================================================= -->


        <div v-if="displayShowPhotos">

            <PhotoGrid :pendingPhotos="pendingPhotos" :approvedPhotos="approvedPhotos"
                @photo-modified="loadShowPhotoImages"></PhotoGrid>

            <br>
            <br>
            <hr>

            <PhotoUpload :showId="showId" @photo-uploaded="onPhotoUploaded"></PhotoUpload>

            <br>
            <br>
            <br>
            <br>
        </div>

        <!-- ======================================================================================= -->


        <div v-if="displayUsedPhotos">

            <UsedPhotosGrid :usedPhotos="usedPhotos"></UsedPhotosGrid>

            <br>
            <br>
        </div>




    </div>
</template>

<script>
import { pProvShow } from '../../../photo-prov-shared/lib/classes/pprovShow.mjs';
import PhotoUpload from '../../../photo-prov-shared/lib/components/PhotoUpload.vue';
import QRCode from '../../../photo-prov-shared/lib/components/QRCode.vue';
import PhotoGrid from './PhotoGrid.vue';
import UsedPhotosGrid from './UsedPhotosGrid.vue';

export default {
    name: 'ShowDetails',
    components: {
        QRCode,
        PhotoUpload,
        PhotoGrid,
        UsedPhotosGrid
    },
    props: {
        showToView: {
            type: Object,
            required: true,
        },
        idToken: {
            type: String,
            required: true
        },
        startInEditMode: {
            type: Boolean,
            default: false
        },
    },
    emits: [
        'close-details',
        'show-modified',
        'photo-modified',
    ],
    data() {
        return {
            displayShowDetails: true,
            displayShowEdits: false,
            displayShowPhotos: false,
            displayUsedPhotos: false,
            show: new pProvShow(this.showToView),
            pendingPhotos: [],
            approvedPhotos: [],
            usedPhotos: [],
            errorMsg: null,
        };
    },
    computed: {
        showId() {
            return this.show.id;
        },
        audienceAppUrl() {
            return this.show.audienceAppUrl;
        },
        formattedDateWithWeekday() {
            return this.show.showDateWithWeekday();
        },
        formattedShortDate() {
            return this.show.showDateShort();
        },
    },
    watch: {
    },
    created() {
        this.loadShowPhotoImages();
    },
    mounted() {
        if (this.startInEditMode) {
            this.viewEdits();
        }
        else {
            this.viewDetails();
        }
    },
    methods: {
        viewDetails() {
            this.displayShowDetails = true;
            this.displayShowEdits = false;
            this.displayShowPhotos = false;
            this.displayUsedPhotos = false;
        },
        viewEdits() {
            this.displayShowDetails = false;
            this.displayShowEdits = true;
            this.displayShowPhotos = false;
            this.displayUsedPhotos = false;
        },
        viewPhotos() {
            this.displayShowDetails = false;
            this.displayShowEdits = false;
            this.displayShowPhotos = true;
            this.displayUsedPhotos = false;
        },
        viewUsedPhotos() {
            this.displayShowDetails = false;
            this.displayShowEdits = false;
            this.displayShowPhotos = false;
            this.displayUsedPhotos = true;
        },

        onPhotoUploaded() {
            // wait a little bit to get updated photos from server
            setTimeout(() => {
                this.loadShowPhotoImages();
            }, 3500);
        },

        async saveShowData() {
            const authToken = this.idToken;
            const apiEndpoint = process.env.VUE_APP_PRV_API + '/shows';
            // debug... console.log('new show data\n', this.show);

            try {
                //==============================================================
                // send new/updated record to server
                //
                const response = await fetch(apiEndpoint, {
                    method: 'PUT',
                    headers: {
                        'Authorization': `Bearer ${authToken}`,
                    },
                    body: JSON.stringify(this.show)
                });

                if (!response.ok) {
                    // Handle HTTP errors (e.g., 4xx, 5xx)
                    const errorText = await response.text(); // Get error details if available
                    console.error('Fetch error:', response.status, errorText);
                    throw new Error(`HTTP error! status: ${response.status} - ${errorText}`);
                }

                const data = await response.json(); // Parse the JSON response body
                // debug...
                console.log(`fetch from ${apiEndpoint}\nresponse data:\n`, data);

                this.errorMsg = null; // Clear previous errors on success

                //==============================================================
                // notify parent components of changes
                // could probably just send refresh-shows event, but in the future
                // it might be useful to know this particular event happened. 
                //
                this.$emit('show-modified');

                // close edit panel after successful save
                this.$emit('close-details');

            } catch (error) {
                // Handle network errors or errors during fetch/parsing
                console.error('Error fetching data:', error);
                this.errorMsg = 'Error saving show data to server';
                this.shows = []; // Clear shows data on error
            }
        },

        async loadShowPhotoImages() {
            // debug... console.log('============== loadShowPhotoImages ==============');

            //========================================================================
            // call private API to get show data including list of images.
            //========================================================================
            const apiEndpoint = process.env.VUE_APP_PRV_API + '/showdata?showId=' + this.show.id;

            try {
                const response = await fetch(apiEndpoint, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${this.authToken}`,
                    }
                });

                if (!response.ok) {
                    const errorText = await response.text();
                    console.error('Fetch error:', response.status, errorText);
                    throw new Error(`HTTP error! status: ${response.status} - ${errorText}`);
                }

                const showData = await response.json();
                this.pendingPhotos = showData.pendingPhotos;
                this.approvedPhotos = showData.approvedPhotos;
                this.usedPhotos = showData.usedPhotos;


                // debug... console.log(`request sent to ${apiEndpoint}`);
                console.log(`received ${this.pendingPhotos.length} pending photos from server`);

            } catch (error) {
                // Handle network errors or errors during fetch/parsing
                console.error('Error fetching data:', error);
                this.errorMsg = 'Error getting photo data from server';
            }
        },
    }
}
</script>

<style scoped>
/* Add component-specific styles here */
.show-details-container {
    border: 1px solid black;
    padding: 10px;
    margin-top: 10px;
    min-height: 600px;
    background-color: #f9f9f9;
}

#divShowDetails {
    max-width: 450px;
}

.qrCodeDiv {
    border: 0px solid orange;
    text-align: center;
}

.details-value {
    font-weight: bold;
    text-align: right;
}

h2 {
    margin-top: 0;
    color: #333;
}

p {
    color: #555;
}

input {
    background-color: white;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 8px;
    width: 80%;
}
</style>
